import { gql } from 'graphql-request';

export const COFFEE_QUERY = gql`
  query Coffee($id: ID!) {
    coffee(id: $id) {
      id
      name
      origin
      processingType
      varieties
      tastingNotes
      imageUrl
      isOnShelf
      roaster {
        id
        name
        location
        city
        countryCode
      }
    }
  }
`;
